<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<h2 class="fm-title">List of Maps</h2>
<p class="map"> <a href="#/xhtml/08_Chapter02#map1"><span class="map">1.</span> Movement across Flanders, 1914</a></p>
<p class="map"><a href="#/xhtml/08_Chapter02#map2"><span class="map">2.</span> Attack on the Yser, 1914</a></p>
<p class="map"><a href="#/xhtml/08_Chapter02#map3"><span class="map">3.</span> French and Belgian defences, 26 October 1914</a></p>
<p class="map"><span href="#/xhtml/09_Chapter03#map4" title="Link target outside of Sample"><span class="map">4.</span> Nieuwpoort waterways and inundated areas</span></p>
<p class="map"><span href="#/xhtml/09_Chapter03#map5" title="Link target outside of Sample"><span class="map">5.</span> The recapture of Ramskapelle, 30 October 1914</span></p>
<p class="map"><span href="#/xhtml/10_Chapter04#map6" title="Link target outside of Sample"><span class="map">6.</span> The Second Battle of Ypres, April–May 1915</span></p>
<p class="map"><span href="#/xhtml/10_Chapter04#map7" title="Link target outside of Sample"><span class="map">7.</span> Drie-Grachten, Luigem and Merkem</span></p>
<p class="map"><span href="#/xhtml/10_Chapter04#map8" title="Link target outside of Sample"><span class="map">8.</span> Defences north of Diksmuide</span></p>
<p class="map"><span href="#/xhtml/10_Chapter04#map9" title="Link target outside of Sample"><span class="map">9.</span> German defences of Diksmuide and the Minoterie</span></p>
<p class="map1"><span href="#/xhtml/10_Chapter04#map10" title="Link target outside of Sample"><span class="map1">10.</span> The defences of the Grote Wacht</span></p>
<p class="map1"><span href="#/xhtml/13_TourA#map11" title="Link target outside of Sample"><span class="map1">11.</span> Tour A Route Map</span></p>
<p class="map1"><span href="#/xhtml/14_TourB#map12" title="Link target outside of Sample"><span class="map1">12.</span> Tour B Route Map</span></p>
<p class="map1"><span href="#/xhtml/15_TourC#map13" title="Link target outside of Sample"><span class="map1">13.</span> Tour C Route Map</span></p>
<p class="map1"><span href="#/xhtml/16_TourD#map14" title="Link target outside of Sample"><span class="map1">14.</span> Tour D Route Map</span></p>
<p class="map1"><span href="#/xhtml/17_TourE#map15" title="Link target outside of Sample"><span class="map1">15.</span> Tour E Route Map</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_listofmaps.vue?e82751d0